import {
  REACT_APP_FEATURE_FLAG_CONTINGENCIES_DATATABLE,
  REACT_APP_FEATURE_FLAG_CONTINGENCIES_HOME,
  REACT_APP_FEATURE_FLAG_CONTINGENCIES_SELECT_OPTIONS,
  REACT_APP_FEATURE_FLAG_CONTINGENCIES_EXPENSE_DOWNLOAD,
  REACT_APP_FEATURE_FLAG_SELECT_ORGANISM_TYPE,
  REACT_APP_FEATURE_FLAG_MARQUEE
} from './environment'

export const features = {
  'select.organism.type':
    REACT_APP_FEATURE_FLAG_SELECT_ORGANISM_TYPE === true || REACT_APP_FEATURE_FLAG_SELECT_ORGANISM_TYPE === 'true',
  'contingencies.home':
    REACT_APP_FEATURE_FLAG_CONTINGENCIES_HOME === true || REACT_APP_FEATURE_FLAG_CONTINGENCIES_HOME === 'true',
  'contingencies.select.options':
    REACT_APP_FEATURE_FLAG_CONTINGENCIES_SELECT_OPTIONS === true ||
    REACT_APP_FEATURE_FLAG_CONTINGENCIES_SELECT_OPTIONS === 'true',
  'contingencies.datatatable':
    REACT_APP_FEATURE_FLAG_CONTINGENCIES_DATATABLE === true ||
    REACT_APP_FEATURE_FLAG_CONTINGENCIES_DATATABLE === 'true',
  'contingencies.expense.download':
    REACT_APP_FEATURE_FLAG_CONTINGENCIES_EXPENSE_DOWNLOAD === true ||
    REACT_APP_FEATURE_FLAG_CONTINGENCIES_EXPENSE_DOWNLOAD === 'true',
  marquee: REACT_APP_FEATURE_FLAG_MARQUEE === true || REACT_APP_FEATURE_FLAG_MARQUEE === 'true'
}
